import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0afeaaa2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "user-name" }
const _hoisted_6 = { class: "global-name" }
const _hoisted_7 = { class: "username" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "guilds" }
const _hoisted_10 = {
  key: 2,
  class: "noGuilds"
}
const _hoisted_11 = {
  key: 3,
  class: "guilds-container"
}
const _hoisted_12 = { class: "guild" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "guild-buttons" }

import {computed, onMounted, ref} from "vue";
import {useStore} from "vuex";
import Oauth2 from "@/utils/Oauth2";
import config from "@/config.json"
import i18n from "@/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'MeView',
  setup(__props) {

if(!localStorage.getItem('token')) window.location.replace('/');

const store = useStore();
const showItems = computed(() => [
  {title: i18n.global.t('Me.settings'), value: false},
  {title: i18n.global.t('Me.leaders'), value: true}
]);
let leaders = ref(false);
let loggingOut = ref(false);
let loadingGuilds = ref(false);

let user = computed(() => {
  document.title = store.getters.user.username ?? '';
  return store.getters.user;
})
let guilds = computed(() => store.getters.guilds)

function generateInvite(guildID: string) {
  return `https://discord.com/api/oauth2/authorize?client_id=${config.botID}&response_type=code` +
      `&permissions=1515519995134&redirect_uri=${encodeURIComponent(window.location.origin + '/landing')}` +
      `&guild_id=${guildID}&scope=bot`
}

async function loadGuilds() {
  loadingGuilds.value = true;
  await store.dispatch('getGuilds')
  loadingGuilds.value = false;
}

async function logout() {
  loggingOut.value = true;
  let response = await Oauth2.revokeToken(localStorage.getItem('token') as string);
  if(!response) return;
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  window.location.replace('/');
}

onMounted(async () => {
  store.dispatch('getUserBadges').then();
  if(guilds.value.length <= 1) await loadGuilds();
})

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (!_unref(user).username)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_v_progress_circular, {
            size: 100,
            width: 7,
            indeterminate: ""
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_v_img, {
            class: "user-avatar item-center",
            "lazy-src": _unref(user).avatarURL,
            src: _unref(user).avatarURL
          }, null, 8, ["lazy-src", "src"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(user).global_name), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(user).username), 1)
          ]),
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(user).botBadges, (badge) => {
              return (_openBlock(), _createBlock(_component_v_tooltip, {
                location: "top",
                color: "black",
                "open-on-click": ""
              }, {
                activator: _withCtx(({ props }) => [
                  _createElementVNode("img", _mergeProps({
                    src: require(`@/assets/badges/${badge}.png`),
                    class: "user-badge",
                    ref_for: true
                  }, props, { alt: "" }), null, 16, _hoisted_8)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(`Me.badges.${badge}`)), 1)
                ]),
                _: 2
              }, 1024))
            }), 256))
          ]),
          _createVNode(_component_v_btn, {
            class: "user-action",
            color: "red",
            loading: _unref(loggingOut),
            variant: "outlined",
            size: "large",
            onClick: logout
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { class: "logout-icon" }, {
                default: _withCtx(() => [
                  _createTextVNode("logout")
                ]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('Me.logout')), 1)
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(_component_v_btn, {
            class: "user-action",
            disabled: _unref(loadingGuilds),
            color: "blue-grey",
            variant: "outlined",
            size: "large",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (loadGuilds(true)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { large: "" }, {
                default: _withCtx(() => [
                  _createTextVNode("refresh")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createElementVNode("div", _hoisted_9, [
            (_unref(loadingGuilds))
              ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                  key: 0,
                  size: 60,
                  width: 5,
                  indeterminate: ""
                }))
              : _createCommentVNode("", true),
            (!_unref(loadingGuilds))
              ? (_openBlock(), _createBlock(_component_v_select, {
                  key: 1,
                  class: "show-select item-center",
                  items: showItems.value,
                  modelValue: _unref(leaders),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(leaders) ? (leaders).value = $event : leaders = $event)),
                  label: _ctx.$t('Me.show'),
                  color: "primary"
                }, null, 8, ["items", "modelValue", "label"]))
              : _createCommentVNode("", true),
            (_unref(guilds).filter(guild => guild.manageable || (_unref(leaders) && guild.invited)).length <= 0 && !_unref(loadingGuilds))
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, "¯\\_(ツ)_/¯"))
              : _createCommentVNode("", true),
            (!_unref(loadingGuilds))
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(guilds).filter(g => g.manageable || (_unref(leaders) && g.invited)), (guild) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", null, [
                          _createElementVNode("img", {
                            src: guild.icon ?? 'https://media.discordapp.net/attachments/708680940385337386/1254418216105803868' +
                '/discord-icon-2048x2048-kva2hfax.png?ex=66796b80&is=66781a00&hm=8f526aeb60e9a192cfe6e46b63d2bb5cf7652' +
                 '90fd1a4746dcb6d6c8731c04af8&=&format=webp&quality=lossless&width=662&height=662'+
                 '&width=662&height=662',
                            class: "guild-icon",
                            alt: "Icon"
                          }, null, 8, _hoisted_13)
                        ]),
                        _createTextVNode(" " + _toDisplayString(guild.name.length <= 25 ? guild.name : guild.name.slice(0, 25) + '...'), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_v_divider, { class: "guild-divider" }),
                        _createElementVNode("div", _hoisted_14, [
                          (!guild.invited && guild.manageable)
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 0,
                                class: "action-button",
                                color: "blue",
                                variant: "outlined",
                                href: generateInvite(guild.id)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('Me.invite')), 1)
                                ]),
                                _: 2
                              }, 1032, ["href"]))
                            : _createCommentVNode("", true),
                          (guild.invited && guild.manageable)
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 1,
                                class: "action-button",
                                color: "blue-grey lighten-1",
                                variant: "outlined",
                                to: `/guilds/${guild.id}/general`
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('Me.settings')), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : _createCommentVNode("", true),
                          (_unref(leaders) && guild.invited)
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 2,
                                class: "action-button",
                                color: "warning",
                                variant: "outlined",
                                to: `/leaderboard/${guild.id}`
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('Me.leaders')), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  }), 256))
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
  ]))
}
}

})